<template>
  <div class="link">
    <div class="card">
      <div class="fields">
        <div class="field">
          <div class="form-group">
            <label :for="id('url', link)">
              {{ lang.get('entries.form.link-url.label') }}
            </label>
            <help-icon :content="lang.get('entries.form.link-url.helptext')" />
            <a class="delete-link" @click.prevent="$emit('delete', link)">
              {{ lang.get('entries.form.link-delete') }}
            </a>
            <input
              :id="id('url', link)"
              type="text"
              :value="link.url"
              :disabled="isDisabled"
              class="form-control"
              placeholder="https://"
              data-filter="url"
              @input="updateUrl"
            />
          </div>
        </div>
        <div class="field">
          <div class="form-group">
            <label :for="id('extra', link)">
              {{ lang.get('entries.form.link-extra.label') }}
            </label>
            <span class="optional-field">
              {{ lang.get('miscellaneous.optional') }}</span
            >
            <help-icon
              :content="lang.get('entries.form.link-extra.helptext')"
            />
            <resizable-textarea
              :id="id('extra', link)"
              :value="link.extra"
              :disabled="isDisabled"
              class="form-control"
              @input="updateExtra"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import HelpIcon from '../../../lib/components/Shared/HelpIcon';
import ResizableTextarea from '../../../lib/components/Shared/ResizableTextarea';

export default {
  inject: ['lang'],
  components: {
    HelpIcon,
    ResizableTextarea
  },
  props: {
    link: {
      type: Object,
      required: true
    }
  },
  computed: {
    isDisabled() {
      return this.locks.lockedOnSubmission;
    },
    ...mapState('entryForm', ['locks'])
  },
  methods: {
    ...mapMutations('entryForm', ['updateLink']),
    id(prefix, link) {
      return 'entry-link-' + prefix + link.id;
    },
    updateUrl(event) {
      this.updateLink({ ...this.link, url: event.target.value });
    },
    updateExtra(value) {
      this.updateLink({ ...this.link, extra: value });
    }
  }
};
</script>
